// extracted by mini-css-extract-plugin
export default {"loginFormForgot":"signin_loginFormForgot__N1XCW","ant-col-rtl":"signin_ant-col-rtl__QFl-h","loginFormButton":"signin_loginFormButton__Fj9G7"};